import galleryEmbed from './galleryEmbed.component';

export default galleryEmbed;
